import React, { Component } from 'react'
import CheckLoginStatus from '../../conditions/CheckLoginStatus'
import WithPatient from '../../conditions/WithPatient'
import SessionLayout from '../../layouts/SessionLayout'
import UseContent from './UseContent'

export default class Use extends Component {
  render() {
    const { match } = this.props
    const { session, patientID } = match.params

    return (
      <CheckLoginStatus loggedOutRedirect="/">
        <WithPatient patientID={patientID}>
          <SessionLayout title="titles.use">
            <UseContent session={session} patientID={patientID} />
          </SessionLayout>
        </WithPatient>
      </CheckLoginStatus>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Use/index.js